import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { useService } from '@kaokei/use-vue-service';
import { defineComponent, ref, watch } from 'vue';
import { ExamService } from '@/services/exam/exam.service';
import { QuestionService } from '@/services/exam/question.service';
import QuestionTypeHeader from './QuestionTypeHeader.vue';
import UserInfoCard from './UserInfoCard.vue';
import QuestionMenu from './QuestionMenu.vue';
import QuestionChoice from './QuestionChoice.vue';
import QuestionProgram from './QuestionProgram.vue';
import QuestionFillBlank from './QuestionFillBlank.vue';
import QuestionFile from './QuestionFile.vue';
import { debounce } from 'lodash-es';
export default defineComponent({
  name: 'UserExamBody',
  components: {
    QuestionTypeHeader: QuestionTypeHeader,
    UserInfoCard: UserInfoCard,
    QuestionMenu: QuestionMenu,
    QuestionChoice: QuestionChoice,
    QuestionProgram: QuestionProgram,
    QuestionFillBlank: QuestionFillBlank,
    QuestionFile: QuestionFile
  },
  setup: function () {
    var questionService = useService(QuestionService);
    var examService = useService(ExamService);
    var showMoreTip = ref(false);
    var mainContentRef = ref();
    var updateShowMoreTip = function () {
      if (mainContentRef && mainContentRef.value) {
        var mainDom = mainContentRef.value;
        showMoreTip.value = mainDom.offsetHeight + mainDom.scrollTop + 10 < mainDom.scrollHeight;
      }
    };
    var updateShowMoreTipDebounce = debounce(updateShowMoreTip, 500);
    watch(function () {
      return questionService.question;
    }, updateShowMoreTipDebounce);
    var onChoiceChange = function (answer, question) {
      examService.saveUserAnswer(answer, question);
    };
    var onInputChange = function (answer, question) {
      if (!question) return;
      examService.saveUserAnswer(answer, question);
    };
    var ideIframeRef = ref();
    var onIdeIframeLoaded = function () {
      questionService.setIdeIframe(ideIframeRef.value);
    };
    var onFileUploaded = function (answerData, question, config) {
      if (!question) return;
      examService.saveUserAttachmentAnswer(answerData, question, config).then(function () {
        _message.success('保存成功');
      });
    };
    return {
      questionService: questionService,
      examService: examService,
      showMoreTip: showMoreTip,
      mainContentRef: mainContentRef,
      updateShowMoreTipDebounce: updateShowMoreTipDebounce,
      ideIframeRef: ideIframeRef,
      onChoiceChange: onChoiceChange,
      onInputChange: onInputChange,
      onIdeIframeLoaded: onIdeIframeLoaded,
      onFileUploaded: onFileUploaded
    };
  }
});